import { ENV } from './env'

interface WebSocketClientProps {
  queries?: { [queryName: string]: string }
  handleOpen?: () => void
  handleReceive?: (e: MessageEvent) => void
  handleError?: (e: Event) => void
  handleClose?: (e: CloseEvent) => void
}

export default ({
  queries,
  handleOpen,
  handleReceive,
  handleError,
  handleClose
}: WebSocketClientProps) => {
  const websocketUrl = ENV.flipper_ws_url
  const queryString = new URLSearchParams(queries).toString()
  const websocketConnection = new WebSocket(`${websocketUrl}?${queryString}`)

  websocketConnection.onopen = () => {
    // connection opened
    handleOpen?.()
    console.info(`Connected to "${websocketUrl}"`)
  }

  websocketConnection.onmessage = e => {
    // a message was received
    handleReceive?.(e)
  }

  websocketConnection.onerror = e => {
    // an error occurred
    console.error(
      `Error with "${websocketUrl}": [TYPE ${e.type} | TIMESTAMP ${
        e?.timeStamp || ''
      }]`
    )
    handleError?.(e as Event)
  }

  websocketConnection.onclose = e => {
    // connection closed
    console.info(
      `Closing connection with "${websocketUrl}": [CODE ${e.code} | REASON ${
        e?.reason || 'NONE'
      }]  `
    )
    handleClose?.(e)
  }
  return websocketConnection
}
